module.exports = __webpack_public_path__ + "static/media/Home_TeachOneIcon.3106b9b2.png";